__turbopack_context__.v({
  "active": "UserTable-module__pCaUfa__active",
  "table": "UserTable-module__pCaUfa__table",
  "userCrumb": "UserTable-module__pCaUfa__userCrumb",
});
